// /orgs/$orgSlug/projects/$projectId/ — the project landing page
// (read-only shot list, B1f PR4).
//
// Index child of the project layout route; error handling lives on the
// parent layout's errorComponent.

import { createFileRoute } from '@tanstack/react-router';

import { ProjectPage } from '../components/ProjectPage';

export const Route = createFileRoute('/orgs/$orgSlug/projects/$projectId/')({
  component: ProjectIndexRoute,
});

function ProjectIndexRoute(): React.JSX.Element {
  const { orgSlug, projectId } = Route.useParams();
  return <ProjectPage orgSlug={orgSlug} projectId={projectId} />;
}
